import React, { useEffect, useState } from "react";
import "./productpage.css";
import { Col, Container, Row } from "react-bootstrap";
import Cardproduct from "../cardproduct/cardproduct";
import SideFilter from "../SideFilter/SideFilter";
import { useDispatch, useSelector } from "react-redux";
import { getAllCarAction } from "../../redux/actions/CarAction";
import { TextField } from "@mui/material";
import Pagination from "../Pagination";
const Productpage = ({ update, handleShowDelete, userData }) => {
  const dispatch = useDispatch();
  const [carType, setcarType] = useState([]);
  const [searchword, setsearchword] = useState("");
  const [catFilter, setcategoryFilter] = useState([]);
  useEffect(() => {
    handleSerach()
  }, [searchword, catFilter, carType]);
  const handleSerach = async() => {
 await dispatch(
      getAllCarAction(
        `car_filter=${searchword}&category_ids=${catFilter.join(',')}&car_types=${carType.join(',')}`
      ))
// await dispatch(
//   getAllCarAction(
//     `car_filter=${searchword}`
//   )
//     );
  };
  // useEffect(() => {
  //   dispatch(
  //     getAllCarAction(
  //       `car_filter=${searchword}&category_ids=${catFilter}&car_types=${carType}`
  //     )
  //   );
  // }, []);
  const AllCar = useSelector((state) => state.CarReduser.GetallCar);
  const onPress = async (page) => {
    await dispatch(getAllCarAction(`page=${page}`));
  };
  return (
    <Container>
      {/* <SearchCountResult onClick={''} title={`هناك ${'10'} نتيجة بحث`}/> */}

      <div className="search-bar mt-3">
        {" "}
        <TextField
          label="البحث بالموديل او رقم الشاسية"
          onChange={(e) => setsearchword(e.target.value)}
          type="text"
          variant="outlined"
        />
        <i className="ty fa-solid fa-magnifying-glass"></i>
      </div>
      <Row className="d-flex flex-row">
        <Col sm="2" xs="2" md="1" className="d-flex">
          <SideFilter
            setcategoryFilter={setcategoryFilter}
            catFilter={catFilter}
            carType={carType}
            setcarType={setcarType}
          />
        </Col>
        <Col sm="10" xs="10" md="11">
          <Cardproduct
            userData={userData}
            AllCar={AllCar}
            update={update}
            handleShowDelete={handleShowDelete}
          />
        </Col>
        <Pagination
          pageCount={AllCar && AllCar.total_pages}
          onPress={onPress}
        />
      </Row>
    </Container>
  );
};

export default Productpage;
